<template>
    <div>
        <b-dropdown block dropleft no-caret variant="link">
            <b-dropdown-header>
                <b-row no-gutters>
                    <b-col cols="12">
                        <div class="text-center">
                            <strong>
                                {{
                                    $t('notification.youHaveMessages', {
                                        count: $store.state.notification.items.length,
                                    })
                                }}
                            </strong>
                        </div>
                    </b-col>
                    <b-col v-if="$store.state.notification.items.length">
                        <div class="text-right">
                            <a href="#" @click="updateNotificationsStatus">{{ $t('notification.markAllAsRead') }}</a>
                        </div>
                    </b-col>
                </b-row>
            </b-dropdown-header>
            <template slot="button-content">
                <div class="text-center">
                    <i class="nav-icon fas fa-bell text-muted" v-pill-count="notificationsCount"></i>
                </div>
            </template>
            <div class="list-notifications">
                <b-dropdown-item v-for="notification in $store.state.notification.items" :key="notification.id">
                    <notification :notification="notification" />
                </b-dropdown-item>
            </div>
        </b-dropdown>
    </div>
</template>
<script>
import Notification from './components/notification'
import { proceedWithConfirmation } from '@/lib/sweet-alert'

export default {
    name: 'Notifications',
    components: {
        Notification,
    },
    computed: {
        notificationsCount() {
            return this.$store.state.notification.items.length
        },
    },
    methods: {
        updateNotificationsStatus() {
            proceedWithConfirmation({
                onConfirm: () => this.$store.dispatch('setAllNotificationsAsCompleted'),
            })
        },
    },
}
</script>
<style scoped lang="scss">
::v-deep .btn-sm {
    padding: 0;
}

.messages {
    text-align: center;
    font-weight: bold;
}

.mark-as-read {
    font-size: 12px;
    text-align: right;
    cursor: pointer;
}

.list-notifications {
    min-width: 350px;
    max-width: 500px;
    max-height: 550px;
    overflow: auto !important;
}
::v-deep .btn {
    padding: 0;
}
</style>
